import {
  TravelerAllowedRange,
  TravelerRuleWarning,
  TravelerSelectorOptions,
} from '@dynamic-components/booker-v2/shared/traveler-selector/types';
import { BookerType, TravelerSelector } from '@shared/booker';
import { JbFlyoutPlacementEnum } from 'jb-component-library';

export interface TravelerSelectorState {
  content: TravelerSelector;
  bookerType: BookerType;
  placement: JbFlyoutPlacementEnum;
  travelerCountError: string;
  flyOutToFitInput: boolean;
  travelerSelectorId: string;
  showValidationErrors: boolean;
  infantsCountTowardsTotalTravelers: boolean;
  defaultToOneTravellerIfZeroSet: boolean;
}

export const travelerSelectorInitialState: TravelerSelectorState = {
  content: undefined,
  bookerType: BookerType.air,
  placement: JbFlyoutPlacementEnum.bottomStart,
  travelerCountError: '',
  flyOutToFitInput: false,
  travelerSelectorId: '',
  showValidationErrors: false,
  infantsCountTowardsTotalTravelers: false,
  defaultToOneTravellerIfZeroSet: false,
};

export interface TravelerSelectorViewModel extends TravelerSelectorState {
  travelersSummary: { full: string; compact: string };
  rules: TravelerRuleWarning[];
  travelerAllowedRange: TravelerAllowedRange[];
  options: TravelerSelectorOptions;
  maxGroups: number;
}
